import React from "react";
import { SkeletonText } from "../UI/DesignStandards/Skeleton";
import { formatCurrency, formatPosition } from "../UI";

const PrizeBreakdownTable = ({ breakdown, tournamentId, loading = false }) => {
  if (loading) {
    return (
      <div className="card-board overflow-hidden">
        <div className="overflow-x-auto">
          <table
            className="min-w-full divide-y divide-brand-charcoal/10"
            role="table"
            aria-label="Prize breakdown by bowler"
          >
            <thead className="bg-brand-charcoal">
              <tr>
                <th
                  scope="col"
                  className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
                >
                  Bowler
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
                >
                  Total Prizes
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
                >
                  Individual
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
                >
                  Team
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
                >
                  Events
                </th>
                <th
                  scope="col"
                  className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
                >
                  Details
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-brand-charcoal/10">
              {Array.from({ length: 5 }).map((_, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-white" : "bg-brand-cream/60"}
                >
                  <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                    <SkeletonText
                      size="xs"
                      className="h-3 sm:h-4 w-20 sm:w-32 flex-shrink-0"
                    />
                  </td>
                  <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                    <SkeletonText
                      size="xs"
                      className="h-3 sm:h-4 w-16 sm:w-24 flex-shrink-0"
                    />
                  </td>
                  <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                    <SkeletonText
                      size="xs"
                      className="h-3 sm:h-4 w-12 sm:w-20 flex-shrink-0"
                    />
                  </td>
                  <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                    <SkeletonText
                      size="xs"
                      className="h-3 sm:h-4 w-12 sm:w-16 flex-shrink-0"
                    />
                  </td>
                  <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                    <SkeletonText
                      size="xs"
                      className="h-3 sm:h-4 w-12 sm:w-16 flex-shrink-0"
                    />
                  </td>
                  <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                    <SkeletonText
                      size="xs"
                      className="h-3 sm:h-4 w-16 sm:w-20 flex-shrink-0"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  if (!breakdown || breakdown.length === 0) {
    return (
      <div className="text-center py-8 text-brand-muted">
        <p className="text-brand-muted">No prize data available.</p>
      </div>
    );
  }

  return (
    <div className="card-board overflow-hidden">
      <div className="overflow-x-auto">
        <table
          className="min-w-full divide-y divide-brand-charcoal/10"
          role="table"
          aria-label="Prize breakdown by bowler"
        >
          <thead className="bg-brand-charcoal">
            <tr>
              <th
                scope="col"
                className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
              >
                Bowler
              </th>
              <th
                scope="col"
                className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
              >
                Total Prizes
              </th>
              <th
                scope="col"
                className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
              >
                Individual
              </th>
              <th
                scope="col"
                className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
              >
                Team
              </th>
              <th
                scope="col"
                className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
              >
                Events
              </th>
              <th
                scope="col"
                className="px-2 sm:px-3 md:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs md:text-sm font-display font-bold tracking-wider uppercase text-brand-cream bg-brand-charcoal"
              >
                Details
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-brand-charcoal/10">
            {breakdown.map((bowler, index) => (
              <tr
                key={bowler.bowlerId}
                className={index % 2 === 0 ? "bg-white" : "bg-brand-cream/60"}
              >
                <td
                  className={`px-2 sm:px-3 md:px-6 py-3 sm:py-4 ${
                    index % 2 === 0 ? "whitespace-nowrap" : "whitespace-nowrap"
                  }`}
                >
                  <div
                    className={`text-[10px] sm:text-xs md:text-sm font-medium text-brand-charcoal max-w-[120px] sm:max-w-none truncate`}
                    title={bowler.bowlerName || "Unknown Bowler"}
                  >
                    {bowler.bowlerName || "Unknown Bowler"}
                  </div>
                </td>
                <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                  <div className="text-[10px] sm:text-xs md:text-sm font-score font-semibold text-brand-charcoal">
                    {formatCurrency(bowler.totalPrizes)}
                  </div>
                </td>
                <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                  <div className="text-[10px] sm:text-xs md:text-sm font-score text-brand-charcoal">
                    {formatCurrency(bowler.individualPrizes)}
                  </div>
                </td>
                <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                  <div className="text-[10px] sm:text-xs md:text-sm font-score text-brand-charcoal">
                    {formatCurrency(bowler.teamPrizes)}
                  </div>
                </td>
                <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                  <div className="text-[10px] sm:text-xs md:text-sm text-brand-charcoal">
                    {bowler.events.length} event
                    {bowler.events.length !== 1 ? "s" : ""}
                  </div>
                </td>
                <td className="px-2 sm:px-3 md:px-6 py-3 sm:py-4 whitespace-nowrap">
                  <div className="text-[10px] sm:text-xs md:text-sm text-brand-charcoal">
                    <details className="group">
                      <summary className="cursor-pointer text-brand-gold-ink hover:underline font-medium">
                        View Events
                      </summary>
                      <div className="mt-2 p-3 card-inset">
                        <div className="space-y-2">
                          {bowler.events.map((event, eventIndex) => (
                            <div
                              key={`${bowler.bowlerId}-${
                                event.teamId || "no-team"
                              }-${event.eventId || eventIndex}`}
                              className="flex items-center justify-between text-[10px] sm:text-xs md:text-sm"
                            >
                              <div className="flex-1">
                                <span className="font-medium">
                                  {event.eventName || "Unknown Event"}
                                </span>
                                <span className="text-brand-muted ml-2">
                                  (
                                  {event.isIndividualEvent
                                    ? "Individual"
                                    : "Team"}
                                  )
                                </span>
                                {event.teamName && !event.isIndividualEvent && (
                                  <span className="text-brand-muted ml-2">
                                    • {event.teamName}
                                  </span>
                                )}
                              </div>
                              <div className="text-right">
                                <span className="font-score font-medium text-brand-charcoal">
                                  {formatPosition(event.position)}
                                </span>
                                <span className="font-score text-brand-charcoal ml-2 font-medium">
                                  {formatCurrency(event.prize)}
                                </span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </details>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PrizeBreakdownTable;
